import { makeStyles } from "@material-ui/core";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { get } from "lodash";
import moment from "moment";
import { stringify } from "query-string";
import * as React from "react";
import { cloneElement } from "react";
import {
	Button,
	ExportButton,
	sanitizeListRestProps,
	TopToolbar,
	useListContext,
	useTranslate,
} from "react-admin";
import CommandButton from "../components/buttons/CommandButton";
import { API_URL } from "../config";

const useStyles = makeStyles((theme) => ({
	button: {
		"& .MuiButton-label": {
			alignItems: "start",
			"& span": {
				whiteSpace: "nowrap",
			},
		},
	},
}));

const Actions = ({ permissions, ...props }) => {
	const classes = useStyles();
	const { className, exporter, filters, maxResults, ...rest } = props;
	const {
		currentSort,
		resource,
		displayedFilters,
		filterValues,
		showFilter,
		total,
		basePath,
		page,
	} = useListContext();
	const translate = useTranslate();
	const prevMonth = moment().subtract(1, "month");
	const year = parseInt(prevMonth.format("YYYY"), 10);
	const month = parseInt(prevMonth.format("MM"), 10);
	const pdfUrl = () => {
		const params = {
			...filterValues,
			sort: get(currentSort, "field", ""),
			direction: get(currentSort, "order", ""),
			page,
			limit: 2500,
			token: localStorage.getItem("token"),
			pdf: true,
		};
		return `${API_URL}${basePath}?${stringify(params)}`;
	};
	return (
		<TopToolbar className={className} {...sanitizeListRestProps(rest)}>
			{filters &&
				cloneElement(filters, {
					resource,
					showFilter,
					displayedFilters,
					filterValues,
					context: "button",
					className: classes.button,
				})}
			<ExportButton
				disabled={total === 0}
				resource={resource}
				sort={currentSort}
				filterValues={filterValues}
				maxResults={maxResults}
				className={classes.button}
			/>
			{total === 1 && (
				<Button
					disabled={total === 0}
					resource={resource}
					label="resources.user-payments.buttons.export_pdf"
					onClick={() => window.open(pdfUrl())}
					className={classes.button}
				>
					<PictureAsPdfIcon />
				</Button>
			)}
			{permissions && permissions("admin") && (
				<CommandButton
					isButton={true}
					color="primary"
					className={classes.button}
					icon={<AccountBalanceWalletIcon />}
					label={translate("resources.user-payments.buttons.generate")}
					notifySuccess={translate(
						"resources.user-payments.messages.generated"
					)}
					confirmTitle={translate("resources.user-payments.titles.generate")}
					confirmContent={translate(
						"resources.user-payments.messages.generate"
					)}
					command={{
						name: "payments",
						args: ["generate", year, month],
						notify_args: {
							title: translate("resources.user-payments.messages.generated"),
							content: translate("resources.user-payments.messages.generated"),
							resource: "user-payments",
						},
					}}
				/>
			)}
		</TopToolbar>
	);
};

export default Actions;
